/** API Role ↔ UI role fields. */

import { emptyPermissions, mergeRolePermissions } from '../data/staff/permissions';

export function roleFromApi(row) {
  if (!row) return null;
  // getById returns { role, permissions }; list returns Role entity
  const role = row.role || row;
  const rawPerms = row.permissions ?? role.permissions;

  const permissions = Array.isArray(rawPerms)
    ? mergeRolePermissions([
        {
          permissions: rawPerms.reduce((acc, p) => {
            if (!acc[p.module]) acc[p.module] = {};
            acc[p.module][p.action] = true;
            return acc;
          }, emptyPermissions()),
        },
      ])
    : emptyPermissions();

  // If API returns PermissionMap object already
  const permMap =
    rawPerms && !Array.isArray(rawPerms)
      ? { ...emptyPermissions(), ...rawPerms }
      : permissions;

  return {
    id: role.id,
    roleId: role.code ?? '',
    name: role.name ?? '',
    description: role.description ?? '',
    isSystem: Boolean(role.isSystem),
    permissions: permMap,
    active: role.isActive !== false,
    createdAt: role.createdAt ?? null,
    updatedAt: role.updatedAt ?? null,
  };
}

export function roleToApi(ui) {
  if (!ui) return null;
  return {
    name: ui.name,
    description: ui.description || null,
    isActive: ui.active !== false,
  };
}

/** Convert UI permission map → [{ module, action }] */
export function permissionsToApiList(permissions) {
  const list = [];
  Object.entries(permissions || {}).forEach(([module, actions]) => {
    Object.entries(actions || {}).forEach(([action, on]) => {
      if (on) list.push({ module, action });
    });
  });
  return list;
}
